import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import * as ItemService from "../../../../services/ItemService";
import { useTranslation } from "react-i18next";
import ItemPrintForm from "./itemPrint.view";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";

const ExtraInfoPOSAPFormContainer = ({ itemCode, onCancel, onSuccess }) => {
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [items, setItems] = useState({});

  const loadData = useCallback(async () => {
    const filter = {};
    if (itemCode) {
      filter.code = itemCode;
      setInitValues({ itemCode: itemCode });
    }
    const result = await ItemService.filterItems(filter);
    setItems(result);
  }, [setItems]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handlerPrint = async (values) => {
    try {
      if (values) {
        const result = await ItemService.printTag(values);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.items.messages.print.title");
          text = t("forms.items.messages.print.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.items.messages.print.error");
          icon = "error";
        }

        let okAction = () => {
          if (onSuccess) {
            onSuccess();
          }
        };
        ShowDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  return (
    <ItemPrintForm
      items={items}
      initialValues={initValues}
      onSubmit={handlerPrint}
      onBack={onCancel}
    />
  );
};

ExtraInfoPOSAPFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ExtraInfoPOSAPFormContainer;
